export * from "./property-status";
export * from "./vehicleTypesOptions";
export * from "./fileUploadConfig";
export let resetGridSettings = false;
